import { styled } from '@linaria/react';
import { Section as BaseSection, TitleRow as BaseTitleRow } from '../../components/Section';
import { layout, space } from '../../theme/tokens';

export const Section = styled(BaseSection)`
  && {
    padding-bottom: 0;
  }
`;

export const TitleRow = styled(BaseTitleRow)`
  && {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${space['space-300']};
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    gap: ${space['space-200']};
  }
`;

export const CategoryDropdownContainer = styled.div`
  width: fit-content;
`;
